<template>
  <div class="">
    <StepHeader
      :title="title"
      :theme="theme"
    />

    <StepContent :theme="theme">
      <AppButtonList
        :theme="theme"
        :buttons="buttons"
        :value="sourceOfIncomeB"
        @input="$_buttonList_handleInput(buttonListActionName, $event)"
      />
    </StepContent>

    <StepFooter hide-mobile>
      <AppButton
        :theme="theme"
        :loading="submitting"
        @click="handleContinue"
      >
        Continue
      </AppButton>
    </StepFooter>
  </div>
</template>

<script>
import AppButton from '@/components/common/buttons/AppButton'
import AppButtonList from '@/components/common/buttons/AppButtonList'
import StepContent from '@/components/common/step-layout/StepContent'
import StepFooter from '@/components/common/step-layout/StepFooter'
import StepHeader from '@/components/common/step-layout/StepHeader'
import navigation from '@/mixins/navigation'
import buttonList from '@/mixins/button-list'
import submitLoans from '@/mixins/submit/submit-loans'

export default {
  // Name
  name: 'EmploymentStatusInsurance',

  // Components
  components: {
    AppButton,
    AppButtonList,
    StepContent,
    StepFooter,
    StepHeader
  },

  // Mixins
  mixins: [
    buttonList,
    submitLoans,
    navigation
  ],

  // Props
  props: {
    title: {
      type: String,
      default: 'What Is Your Employment Status?'
    },

    theme: {
      type: String,
      default: 'blue'
    }
  },

  // Data
  data () {
    return {
      buttonListActionName: 'setSourceOfIncomeOther',
      buttonListDataLayerStepName: 'income_source',
      buttonListFieldName: 'sourceOfIncomeB',
      buttons: [{
        text: 'Maternity Leave',
        value: 'Maternity Leave',
        dataLayer: 'maternity_leave'
      }, {
        text: 'Seasonal / Shortage of Work',
        value: 'Seasonal/Shortage of Work',
        dataLayer: 'seasonal_shortage_of_work'
      }, {
        text: 'Temporary Layoff',
        value: 'Temporary Layoff',
        dataLayer: 'temporary_layoff'
      }, {
        text: 'Layoff',
        value: 'Layoff',
        dataLayer: 'layoff'
      }, {
        text: 'Other (Not Listed)',
        value: 'Other',
        dataLayer: 'other'
      }]
    }
  },

  // Computed
  computed: {
    sourceOfIncomeB () {
      return this.$store.state.employment.source_of_income_b
    },

    sourceOfIncome () {
      return this.$store.state.employment.source_of_income
    },

    updateLeadPayload () {
      return { source_of_income: this.sourceOfIncome }
    }
  },

  watch: {
    $_navigation_triggerContinue: async function (val) {
      if (val) await this.handleContinue()
      this.$store.dispatch('setTriggerContinue', false)
    }
  },

  methods: {
    async handleContinue () {
      this.$_loans_updateLead(this.updateLeadPayload, this.dataLayerObject)
    }
  }
}
</script>

<style scoped lang="scss">
</style>
